<template>
  <transition name="toast-fade">
    <div v-if="visible" class="toast" :class="type">
      <slot>{{ message }}</slot>
    </div>
  </transition>
</template>

<script setup lang="ts">
defineProps<{
  visible: boolean;
  message: string;
  type?: string;
}>();
</script>

<style scoped>
.toast {
  position: fixed;
  left: 50%;
  top: 50%;
  z-index: 9999;
  min-width: 100px;
  max-width: 85vw;
  padding: 12px 24px;
  border-radius: 6px;
  background: rgba(34, 34, 34, 0.92);
  color: #fff;
  text-align: center;
  font-size: 15px;
  transform: translate(-50%, -50%);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.11);
  transition: all 0.23s;
}
.toast.success {
  background: #444;
}
.toast.error {
  background: #d04545;
}
.toast.loading {
  background: #444;
}
.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: opacity 0.3s;
}
.toast-fade-enter-from,
.toast-fade-leave-to {
  opacity: 0;
}
</style>
